import './MaximizeButton.scss';

import {useSelector} from 'react-redux';
import React from 'react';

import Button from '../../../elements/Button/Button';
import Icon from '../../../elements/icons/Icon';


const MaximizeButton = props => {
    const {className = ''} = props,
        maximize = useSelector(state => state.ui.sidePanel.maximize),
        collapseIcon = !maximize ? 'download-solid' : 'upload-solid';

    const handleToggleMaximize = () => {
        app.store.dispatch(app.actions.ui.sidePanel.toggleMaximize());
    };

    return (
        <Button className={`${className} MaximizeButton`} onClick={handleToggleMaximize}>
            <Icon
                size={24}
                style={{
                    transform: 'rotate(90deg) rotateY(180deg)',
                }}
                src={`img/svg/${collapseIcon}.svg`}
            />
        </Button>
    );
};

export default MaximizeButton;
